// bao migrate skip
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import BaseModel2 from "models/base-model2";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-toolbar2";
import GenericListTab from "./../../factories/generic-list-tab";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class PurchaseVendorArtikelTab extends GenericListTab {
    PurchaseVendor: any;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 1000;
        this.PurchaseVendor = parent;
    }
    ControllerUrl = "PurchaseVendorArtikelTab";
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    Dialog(id: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item = dialog.ViewModel();
                item.PurchaseVendorId = this.PurchaseVendor.PurchaseVendorId();
                delete item.Parent;
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        this.Save(this.MinimizeEntity(item)).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    Save(item): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post(this.UrlSave(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            model: item
        }), () => {
            this.Get().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    MinimizeEntity(item) {
        var result = ko.map.toJS(item);
        return result;
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
}
export default PurchaseVendorArtikelTab;